import React, { useContext, useState, useEffect } from "react";
import CensusService from "../../../_services/Census/CensusService";
import { DashboardContext } from "states/DashboardContext";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import AddIcon from "@mui/icons-material/Add";

const censusService = CensusService();

const CensusYearsDropDown = () => {
  const { selectedYearState } = useContext(DashboardContext);
  const [selectedYear, setSelectedYear] = selectedYearState;
  const [censusYears, setCensusYears] = useState([]);
  const [anchorEls, setAnchorEls] = React.useState({
    indicatorPopover: null,
    areaPopover: null,
    yearPopover: null,
  });

  const handleClick = (event, popoverName) => {
    setAnchorEls({ ...anchorEls, [popoverName]: event.currentTarget });
  };

  const handleClose = (popoverName) => {
    setAnchorEls({ ...anchorEls, [popoverName]: null });
  };

  //implementation to select census years
  async function fetchCensusYears() {
    try {
      const response = await censusService.getCensusYears();
      setCensusYears(response);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchCensusYears();
  }, []);

  const handleChangeSelectingCensusYear = (year) => {
    setSelectedYear((prev) =>
      prev.some((y) => y.time_value === year.time_value)
        ? prev.filter((y) => y.time_value !== year.time_value)
        : [...prev, year]
    );
  };

  //Handle selecting all years
  const isAllSelected = selectedYear.length === censusYears.length;
  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedYear([]);
    } else {
      setSelectedYear(censusYears);
    }
  };

  return (
    <>
      {/* <div className="flex flex-row p-0 items-center"> */}
      <div className="w-1/6 pb-1">
        <Button
          onClick={(e) => handleClick(e, "yearPopover")}
          sx={{
            backgroundColor: "#fff",
            color: "black",
            paddingTop: 0,
            paddingBottom: 0,
            textTransform: "none",
            border: "1px solid #ddd",
            boxShadow: "none",
            borderRadius: "6px",
            display: "flex",
            paddingRight: "44px",
            alignItems: "center",
            gap: "6px",
          }}
          variant="contained"
        >
          <AddIcon className="text-sm" />
          Select Years
        </Button>
      </div>
      {/* Popover for years */}

      <Popover
        open={Boolean(anchorEls.yearPopover)}
        onClose={() => handleClose("yearPopover")}
        anchorEl={anchorEls.yearPopover}
        anchorReference="anchorPosition"
        anchorPosition={{
          top: window.innerHeight / 2,
          left: window.innerWidth / 2,
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
      >
        <div className="flex justify-between p-0 bg-gray-100">
          <Typography sx={{ p: 1 }}>Select Years</Typography>
          <button
            onClick={() => handleClose("yearPopover")}
            className="px-6 border border-blue-400 mr-5 rounded-12"
          >
            Save
          </button>
        </div>

        <Box
          sx={{
            gap: 2,
            width: "600px", // Adjust width based on content
            padding: "10px",
            height: "400px",
            marginLeft: "30px",
          }}
        >
          <div className="flex flex-row items-center">
            <Checkbox checked={isAllSelected} onChange={handleSelectAll} />
            <Typography sx={{ fontWeight: "bold" }} className="font-bold">
              Select All Years
            </Typography>
          </div>
          {censusYears
            ?.slice()
            .sort((a, b) => b.time_value - a.time_value)
            .map((year) => (
              <div className="flex flex-row items-center">
                <Checkbox
                  checked={selectedYear.some(
                    (y) => y.time_value === year.time_value
                  )}
                  onChange={() => handleChangeSelectingCensusYear(year)}
                />
                {year.time_value}
              </div>
            ))}
        </Box>
      </Popover>
      {/* </div> */}
    </>
  );
};

export default CensusYearsDropDown;
